import OpenAIApi from '../../../apis/openai-api';
import { Auth } from 'aws-amplify';
import { getEnvSpecificAxiosInstance } from '../../../utils';

export const createCompletion = async (completion) => {
  const INSTANCE = await getEnvSpecificAxiosInstance('application/json', OpenAIApi,'openai','completions');
  return await INSTANCE.AXIOS.post(INSTANCE.URL, completion, INSTANCE.config);
};

export const baseCompletionPayload = async () => {
  return {
    model: 'text-davinci-003',
    max_tokens: 500,
    temperature: 0.5,
    user: (await Auth.currentSession()).getIdToken().payload['email'],
    prompt: '',
  };
};
